import { vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, vModelText as _vModelText, withKeys as _withKeys, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = ["id"]
const _hoisted_2 = ["name", "value"]
const _hoisted_3 = ["name", "value"]
const _hoisted_4 = { class: "input-group" }
const _hoisted_5 = ["onUpdate:modelValue", "id", "name", "tabindex", "readonly", "disabled"]
const _hoisted_6 = ["onClick"]

import {computed, inject} from 'vue'
import { useComponentClassesToRender } from 'fallco-frontend-framework/src/vue/composable/useComponent.js'
import {usePraticaStore} from "../../../store/crm.store";
import {add, trash} from "../../../svg/svgs.js"



//TODO: togliere pratica_id dal componente input generico oppure spostare componente all'interno del progetto del CRM
const __default__ = {
  name: 'BaseInputArray'
}

export default /*@__PURE__*/Object.assign(__default__, {
  props: {
  /**
   * Nome/ID del campo
   */
  name: {
    type: String,
    default: null
  },
  /**
   * Valore del campo ereditato dal padre
   */
  value: {
    type: Array,
    default() {
      return []
    }
  },
  elementDescrizione: {
    type: String,
    default: ''
  },
  elementId: {
    type: String,
    default: ''
  },
  /**
   * Stato del campo
   * readonly - disabled
   */
  state: {
    type: String,
    default: null
  },
  /**
   * Se true il campo è required
   */
  fwRequired: {
    type: Boolean,
    default: false
  }
},
  emits: ['update'],
  setup(__props, { emit: __emit }) {

const props = __props
const emits = __emit

const praticaStore = usePraticaStore();

const items = computed(() => {
  return props.value;
})

const updateValue = () => {
  emits('update', items.value)
}

const removeElement = (event, index) => {
  items.value.splice(index, 1);
  updateValue()
}

const addElement = () => {
  let newItem                      = {}
  newItem.pratica_id               = praticaStore.praticaID;
  newItem[props.elementDescrizione] = '';
  newItem[props.elementId]          = '';
  items.value.push(newItem);
  updateValue();
}

const gestioneFocus = async (event) => {
  event.preventDefault();
  await addElement();
  let refName = props.name + '['+(items.value.length - 1)+']['+props.elementDescrizione+']'
  document.querySelector('[name="'+refName+'"]').focus();
}

const classToRender = computed(() => {
  return useComponentClassesToRender(null, {
    // classes of parent div element
  })
})

const $DesignSystem = inject('$DesignSystem')

return (_ctx, _cache) => {
  const _component_base_icon = _resolveComponent("base-icon")

  return (_openBlock(), _createElementBlock("div", null, [
    _withDirectives(_createElementVNode("input", {
      type: "text",
      readonly: "",
      class: "form-control-plaintext",
      id: __props.name,
      value: "-",
      placeholder: "-"
    }, null, 8 /* PROPS */, _hoisted_1), [
      [_vShow, items.value.length === 0]
    ]),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(items.value, (item, index) => {
      return (_openBlock(), _createElementBlock("div", {
        class: _normalizeClass({ 'mb-3': index !== items.value.length - 1 && __props.state === 'active' }),
        key: index
      }, [
        _createElementVNode("input", {
          type: "hidden",
          name: `${__props.name}[${index}][pratica_id]`,
          value: _unref(praticaStore).praticaID
        }, null, 8 /* PROPS */, _hoisted_2),
        _createElementVNode("input", {
          type: "hidden",
          name: `${__props.name}[${index}][${__props.elementId}]`,
          value: item[__props.elementId]
        }, null, 8 /* PROPS */, _hoisted_3),
        _createElementVNode("div", _hoisted_4, [
          _withDirectives(_createElementVNode("input", {
            type: "text",
            "onUpdate:modelValue": $event => ((items.value[index][__props.elementDescrizione]) = $event),
            id: `${__props.name}[${index}][${__props.elementDescrizione}]`,
            name: `${__props.name}[${index}][${__props.elementDescrizione}]`,
            class: _normalizeClass({ 'form-control-plaintext': __props.state === 'readonly', 'form-control' : __props.state !== 'readonly' }),
            onKeydown: _cache[0] || (_cache[0] = _withKeys($event => (gestioneFocus($event)), ["enter"])),
            ref_for: true,
            ref: `${__props.name}[${index}][${__props.elementDescrizione}]`,
            tabindex: index,
            readonly: __props.state==='readonly',
            disabled: __props.state==='disabled'
          }, null, 42 /* CLASS, PROPS, NEED_HYDRATION */, _hoisted_5), [
            [_vModelText, items.value[index][__props.elementDescrizione]]
          ]),
          _withDirectives(_createElementVNode("button", {
            class: "input-group-text crm:bg-white",
            title: "Rimuovi questo estremo",
            type: "button",
            onClick: _withModifiers($event => (removeElement($event, index)), ["prevent"])
          }, [
            _createVNode(_component_base_icon, {
              icon: _unref(trash),
              stroke: _unref($DesignSystem).design_colors.primary
            }, null, 8 /* PROPS */, ["icon", "stroke"])
          ], 8 /* PROPS */, _hoisted_6), [
            [_vShow, __props.state === 'active']
          ])
        ])
      ], 2 /* CLASS */))
    }), 128 /* KEYED_FRAGMENT */)),
    (__props.state ==='active')
      ? (_openBlock(), _createElementBlock("button", {
          key: 0,
          class: "btn btn-default mt-3 crm:flex crm:items-center!",
          type: "button",
          onClick: _cache[1] || (_cache[1] = _withModifiers($event => (addElement($event)), ["prevent"]))
        }, [
          _cache[2] || (_cache[2] = _createTextVNode(" Aggiungi estremo ", -1 /* CACHED */)),
          _createVNode(_component_base_icon, {
            icon: _unref(add),
            "stroke-width": "2",
            sizing: {width: '15px', height: '15px'},
            class: "crm:ml-2"
          }, null, 8 /* PROPS */, ["icon"])
        ]))
      : _createCommentVNode("v-if", true)
  ]))
}
}

})